import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useMutation } from '@tanstack/react-query';

import { fetchWithTimeout, REQUEST_TIMEOUT } from '../helpers/apiHelper';
import { trackAI } from '../helpers/telemetryHelper';

type Vars = { url: string; payload: unknown; timeout?: number };
type Out = number | undefined;

export function useHandleCallback() {
  return useMutation<Out, Error, Vars>({
    mutationFn: async ({ url, payload, timeout = REQUEST_TIMEOUT }) => {
      const res = await fetchWithTimeout(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        timeout,
      });
      return res.status;
    },
    onError: (error, { url, payload }) => {
      trackAI(
        `Request failed for '${url}' and payload '${JSON.stringify(payload)}' with error message: '${error.message}'`,
        SeverityLevel.Error,
      );
    },
    retry: 0,
  });
}
